/**
 * Toggles a checkbox programmatically and triggers change event
 * @param {string} checkboxId - The ID of the checkbox element to toggle
 * @returns {boolean} - Returns true if toggle was successful, false otherwise
 */
export const toggleCheckbox = (checkboxId) => {
    const checkbox = document.getElementById(checkboxId);
    if (checkbox && checkbox.type === 'checkbox') {
        checkbox.checked = !checkbox.checked;
        // Triggers change event to ensure any CSS transitions work
        checkbox.dispatchEvent(new Event('change'));
        return true;
    }
    return false;
};

export const handleKeyDownPress = (
    e,
    callback,
) => {
    if (e.key === "Enter" || e.key === "space" || e.key === " ") {
        e.preventDefault();
        callback();
    }
};